export interface SlaWindowThread {
	replied: boolean | null | undefined
	slaDeadlineAt: number
	lastInboundMessageAt: number | null | undefined
	lastOutboundMessageAt: number | null | undefined
}

// Every customer message recomputes the deadline from that moment, so a
// deadline older than the latest customer message belongs to a window the
// team already answered and says nothing about the current one.
export function isLeftoverDeadline(
	thread: Pick<SlaWindowThread, "slaDeadlineAt" | "lastInboundMessageAt">,
): boolean {
	const lastInbound = thread.lastInboundMessageAt
	return !!lastInbound && thread.slaDeadlineAt < lastInbound
}

export function owesReplyAgainstDeadline(thread: SlaWindowThread): boolean {
	if (thread.replied) return false
	const lastInbound = thread.lastInboundMessageAt
	if (!lastInbound) return true
	const lastOutbound = thread.lastOutboundMessageAt
	if (lastOutbound && lastOutbound >= lastInbound) return false
	return !isLeftoverDeadline(thread)
}
